// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu About Us Modern Glass Styles
   ========================================== */

.about-page {
  min-height: 100vh;
  padding: 7.25rem 1.5rem 4rem 1.5rem;
}

.about-container {
  max-width: 1080px;
  margin: 0 auto;
  background: var(--bg-glass-card);
  backdrop-filter: blur(20px);
  border-radius: var(--radius-lg);
  border: none !important;
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.about-hero {
  padding: 3rem 1.5rem 2.5rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
}

.about-hero h1 {
  font-size: clamp(2.25rem, 4.5vw, 3.5rem);
  font-weight: 800;
  margin-top: 0.75rem;
  margin-bottom: 1.25rem;
  line-height: 1.2;
}

.about-hero-desc {
  font-size: 1.15rem;
  color: var(--text-muted);
  max-width: 780px;
  margin: 0 auto;
  line-height: 1.7;
}

.about-content {
  padding: 3rem 2.5rem;
}

.about-section {
  margin-bottom: 3.5rem;
}

.about-section h2 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 1.5rem;
  position: relative;
  padding-bottom: 0.5rem;
}

.about-section h2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 45px;
  height: 3px;
  background: var(--grad-primary);
  border-radius: 2px;
}

.about-section p {
  color: var(--text-muted);
  line-height: 1.7;
  font-size: 1rem;
  margin-bottom: 1rem;
}

.mission-cards, .team-grid, .values-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.mission-card, .value-item {
  background: rgba(15, 23, 42, 0.6);
  padding: 2rem;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-glass);
  transition: transform 0.3s ease, border-color 0.3s ease;
}

.mission-card:hover, .value-item:hover {
  transform: translateY(-5px);
  border-color: var(--border-glass-hover);
  box-shadow: var(--shadow-md);
}

.mission-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.mission-card h3, .value-item h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.mission-card p, .value-item p {
  color: var(--text-muted);
  font-size: 0.9rem;
  line-height: 1.6;
}

.value-item {
  border-left: 4px solid var(--color-primary);
}

.stats-section {
  background: rgba(15, 23, 42, 0.7);
  padding: 3rem 2rem;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-glass);
  margin-top: 3.5rem;
}

.stats-section h2 {
  text-align: center;
  font-size: 1.75rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 2rem;
}

.stats-section h2::after {
  left: 50%;
  transform: translateX(-50%);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1.5rem;
}

.stat-item {
  text-align: center;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.03);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-glass);
}

.stat-number {
  font-size: 2.25rem;
  font-weight: 800;
  background: var(--grad-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0.4rem;
}

.stat-label {
  font-size: 0.9rem;
  color: var(--text-muted);
  font-weight: 600;
}

@media (max-width: 768px) {
  .about-content {
    padding: 2rem 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/About.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* ==========================================\n   Kubersetu About Us Modern Glass Styles\n   ========================================== */\n\n.about-page {\n  min-height: 100vh;\n  padding: 7.25rem 1.5rem 4rem 1.5rem;\n}\n\n.about-container {\n  max-width: 1080px;\n  margin: 0 auto;\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(20px);\n  border-radius: var(--radius-lg);\n  border: none !important;\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n}\n\n.about-hero {\n  padding: 3rem 1.5rem 2.5rem;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 3rem;\n}\n\n.about-hero h1 {\n  font-size: clamp(2.25rem, 4.5vw, 3.5rem);\n  font-weight: 800;\n  margin-top: 0.75rem;\n  margin-bottom: 1.25rem;\n  line-height: 1.2;\n}\n\n.about-hero-desc {\n  font-size: 1.15rem;\n  color: var(--text-muted);\n  max-width: 780px;\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\n.about-content {\n  padding: 3rem 2.5rem;\n}\n\n.about-section {\n  margin-bottom: 3.5rem;\n}\n\n.about-section h2 {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 1.5rem;\n  position: relative;\n  padding-bottom: 0.5rem;\n}\n\n.about-section h2::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 45px;\n  height: 3px;\n  background: var(--grad-primary);\n  border-radius: 2px;\n}\n\n.about-section p {\n  color: var(--text-muted);\n  line-height: 1.7;\n  font-size: 1rem;\n  margin-bottom: 1rem;\n}\n\n.mission-cards, .team-grid, .values-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.mission-card, .value-item {\n  background: rgba(15, 23, 42, 0.6);\n  padding: 2rem;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-glass);\n  transition: transform 0.3s ease, border-color 0.3s ease;\n}\n\n.mission-card:hover, .value-item:hover {\n  transform: translateY(-5px);\n  border-color: var(--border-glass-hover);\n  box-shadow: var(--shadow-md);\n}\n\n.mission-icon {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n}\n\n.mission-card h3, .value-item h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.mission-card p, .value-item p {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.value-item {\n  border-left: 4px solid var(--color-primary);\n}\n\n.stats-section {\n  background: rgba(15, 23, 42, 0.7);\n  padding: 3rem 2rem;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-glass);\n  margin-top: 3.5rem;\n}\n\n.stats-section h2 {\n  text-align: center;\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 2rem;\n}\n\n.stats-section h2::after {\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1.5rem;\n}\n\n.stat-item {\n  text-align: center;\n  padding: 1.5rem;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-glass);\n}\n\n.stat-number {\n  font-size: 2.25rem;\n  font-weight: 800;\n  background: var(--grad-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 0.4rem;\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n@media (max-width: 768px) {\n  .about-content {\n    padding: 2rem 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
